import PatchUtils from "../utils/PatchUtils";
import WebService from "./WebService";

class CRUDServiceOperations extends WebService {
  getEntities(
    pageInfo,
    sortInfo,
    callback,
    failureCallback,
    retireveCompactView = false
  ) {
    return this.getEntitiesWithParams(
      undefined,
      pageInfo,
      sortInfo,
      callback,
      failureCallback,
      retireveCompactView
    );
  }

  getEntitiesWithParams(
    url,
    pageInfo,
    sortInfo,
    callback,
    failureCallback,
    retireveCompactView = false
  ) {
    var urlContainsParams = false;
    if (url) {
      urlContainsParams = this.urlFactory.checkUrlContainsParams(url);
    } else {
      url = retireveCompactView
        ? this.getEntitiesCompactViewUrl()
        : this.getEntitiesUrl();
    }
    if (pageInfo || sortInfo) {
      const urlParams = this.urlFactory.constructPaginationAndFilteringUrlQueries(
        pageInfo,
        sortInfo,
        urlContainsParams
      );
      url += urlParams ? urlParams : "";
    }
    return this.getEntitiesByUrl(url, callback, failureCallback);
  }

  getEntitiesByUrl(url, callback, failureCallback) {
    return this.get(url, callback, undefined, failureCallback);
  }

  getEntityById(id, callback, failureCallback) {
    const url = this.urlFactory.itemUrl(this.getEntitiesUrl(), id);
    return this.getEntitiesByUrl(url, callback, failureCallback);
  }

  putEntity(entity, callback, failureCallback, successCallback = undefined) {
    const url = entity._links.self.href;
    return this.put(url, entity, callback, successCallback, failureCallback);
  }

  patchEntity(
    entity,
    oldEntity,
    callback,
    failureCallback,
    successCallback = undefined,
    patchValidPaths = undefined,
    patchInvalidPaths = undefined,
    patchAlwaysIncludedPaths = undefined,
    patchResetArrayPaths = undefined
  ) {
    const url = entity._links.self.href;
    const data = PatchUtils.compare(
      oldEntity,
      entity,
      patchValidPaths,
      patchInvalidPaths,
      patchAlwaysIncludedPaths,
      patchResetArrayPaths
    );
    return this.patch(url, data, callback, successCallback, failureCallback);
  }

  postEntity(entity, callback, failureCallback, successCallback = undefined) {
    const url = this.getEntitiesUrl();
    return this.post(url, entity, callback, successCallback, failureCallback);
  }

  deleteEntity(entity, callback, successCallback = undefined, failureCallback) {
    const url = entity._links.self.href;
    return this.delete(url, callback, successCallback, failureCallback);
  }

  getEntitiesUrl = () => {
    throw new Error("You have to implement the method getEntitiesUrl!");
  };

  getEntitiesCompactViewUrl = () => {
    return this.urlFactory.collectionCompactViewUrl(this.getEntitiesUrl());
  };
}

export default CRUDServiceOperations;
